import React, { useContext } from 'react';
import { useBetBuilderEvents } from './BetBuilderEventsProvider';

import './BetBuilder.css';
import { PrematchContext } from '../Prematch';

export default function BetBuilder() {
    const prematchContext = useContext(PrematchContext);
    const betBuilderEvents = useBetBuilderEvents();

    return (
        <div className="xs_bet-builder-events-grid">
            {betBuilderEvents.events.map(e =>
                <div key={e.uniqueId} className="xs_bet-builder-event" onClick={() => prematchContext.openMatch(e, true)}>
                    <span className="xs_bet-builder-event-date">{e.date}</span>
                    <span className="xs_bet-builder-event-desc">{e.desc}</span>
                </div>
            )}
        </div>
    );
}
